import { LoadingOverlay } from '@mantine/core';
import React from 'react';

import { useConfig, usePortalConfig } from '@portals/api/partners';
import { useCurrentUser } from '@portals/api/ui';

interface PartnerDataLayout {
  children: ({ isFetched }: { isFetched: boolean }) => JSX.Element;
}

export function PartnerDataLayout({ children }: PartnerDataLayout) {
  const config = useConfig();
  const portalConfig = usePortalConfig();
  const currentUser = useCurrentUser();

  const isFetched =
    config.isFetched && portalConfig.isFetched && currentUser.isFetched;

  if (!isFetched) {
    return <LoadingOverlay visible />;
  }

  return <>{children}</>;
}
